import { memo } from "react";
import Required from "@/components/required/Required";
import { literals } from "@/constants/literals";

export interface RadioGroupProps {
  label: string;
  selected: boolean | undefined;
  onChange: (value?: boolean) => void;
}

const RadioGroup = ({ label, selected, onChange }: RadioGroupProps) => {
  const chageToTrue = () => {
    if (selected === undefined) onChange(true);
    else onChange();
  };

  const chageToFalse = () => {
    if (selected === undefined) onChange(false);
    else onChange();
  };

  return (
    <div className="w-full" data-testid={`radio-group-${label}`}>
      <div className="w-full h-[41px] font-ib-bold text-ib-pt-lg flex flex-row items-center gap-x-2 mb-1">
        <span>{label}</span>
        <Required />
      </div>
      <div className="w-full flex flex-row gap-x-6">
        <div className="h-10 w-[103px] border border-ib-pt-color-gray-100 rounded-[2px] p-2 flex items-center">
          <input
            type="radio"
            id={`${label}-yes`}
            name={`${label}-yes`}
            value={"true"}
            className="accent-ib-pt-color-red-500"
            onChange={chageToTrue}
            checked={selected}
          />
          <label
            htmlFor={`${label}-yes`}
            className="text-[14px] leading-5 text-ib-pt-color-neutral-800 ml-2 flex-1"
          >
            {literals.yes}
          </label>
        </div>
        <div className="h-10 w-[103px] border border-ib-pt-color-gray-100 rounded-[2px] p-2 flex items-center">
          <input
            type="radio"
            id={`${label}-no`}
            name={`${label}-no`}
            value="false"
            className="accent-ib-pt-color-red-500"
            onChange={chageToFalse}
            checked={selected === false}
          />
          <label
            htmlFor={`${label}-no`}
            className="text-[14px] leading-5 text-ib-pt-color-neutral-800 ml-2 flex-1"
          >
            {literals.no}
          </label>
        </div>
      </div>
    </div>
  );
};

export default memo(RadioGroup);
